import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScNewBlackjackBetting implements ICommand
{

	public HostID : number = 0;
	public GameID : number = 0;
	public CountDown : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.GameID = ba.readUint53();
		this.CountDown = ba.readUint16();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GameID);
		ba.writeUint16(this.CountDown);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScNewBlackjackBetting();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'CountDown(W)='+this.CountDown+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30054;
	}

	public getCmdName() : string
	{
		return 'ScNewBlackjackBetting';
	}

}
